import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const key = `revimenu_remind_${this.element.dataset.slug}`
    const dismissed = localStorage.getItem(key)
    if (dismissed) return

    this.timeout = setTimeout(() => {
      this.element.classList.remove("hidden")
    }, 30 * 60 * 1000)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    const key = `revimenu_remind_${this.element.dataset.slug}`
    localStorage.setItem(key, "1")
    this.element.classList.add("hidden")
  }
}
